import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: "'Poppins', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '40px',
                    // border: '1px solid lightgrey',
                    borderRadius: '6px',
                    '&:before, &:after': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontSize: '13px',
                    // padding:0
                },
            },
        },
       
      

    },
});

export default theme;
